import { GetCompanyTasksResponse } from '@commenda/types/src/tasks/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

/**
 * Fetches the company-wide task list from the BFF (`GET /company/:companyId/bff/tasks`).
 * Returns `GetCompanyTasksResponse` verbatim — any FE-side post-processing
 * (getTaskLabel for SR tasks, localStorage dismissal filter for SALES_TAX_EXPOSURE)
 * happens in TasksPage on top of this data.
 */
export function useCompanyTasks(companyId: number | null) {
  const { data, error, mutate } = useSWR<GetCompanyTasksResponse>(
    companyId ? `company/${companyId}/bff/tasks` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { data, error, mutate, isLoading: !data && !error };
}
